define( [
	"../Data"
], function( Data ) {
	return new Data();
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/data/var/dataPriv.js
 ** module id = 850
 ** module chunks = 2
 **/